import {
  TROUBLESHOOTING_CONFIG,
  TROUBLESHOOTING_OPTIONS,
  TroubleshootingOption,
} from "../config/troubleshootingConfig";

interface TroubleshootingOptionsProps {
  selected: TroubleshootingOption[];
  onChange: (options: TroubleshootingOption[]) => void;
  disabled?: boolean;
}

export function TroubleshootingOptions({
  selected,
  onChange,
  disabled,
}: TroubleshootingOptionsProps) {
  const toggle = (opt: TroubleshootingOption) => {
    if (selected.includes(opt)) {
      onChange(selected.filter((o) => o !== opt));
    } else {
      onChange([...selected, opt]);
    }
  };

  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Troubleshooting (optional)
        </p>
        <span className="text-[11px] text-gray-400">Add or skip any option</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {TROUBLESHOOTING_OPTIONS.map((opt) => {
          const cfg = TROUBLESHOOTING_CONFIG[opt];
          const active = selected.includes(opt);
          return (
            <button
              key={opt}
              type="button"
              disabled={disabled}
              onClick={() => toggle(opt)}
              title={cfg.description}
              className={`rounded-full border px-3 py-1.5 text-xs font-medium transition ${
                active
                  ? "border-brand-accent bg-brand-accent/10 text-brand-navy"
                  : "border-gray-200 bg-white text-gray-600 hover:border-gray-300"
              } ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
            >
              {active ? "✓ " : "+ "}
              {cfg.label}
            </button>
          );
        })}
      </div>
      {selected.length > 0 && (
        <p className="mt-2 text-xs text-gray-500">
          Selected: {selected.map((o) => TROUBLESHOOTING_CONFIG[o].label).join(", ")}
        </p>
      )}
    </div>
  );
}
